import * as React from 'react';
import { Container, Header, KeyValuePairs } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { Table } from '@amzn/awsui-components-react-v3/polaris';
import { getAmazonApprovalURL } from 'src/api/config';
import { deDupeApprovalsInfoByApprovalWorkflowId } from 'src/components/requests/utils';
import { StatusIcon } from 'src/components/permissions/myDatasets/statusIcon';

export const convertApprovalTemplateIDToLink = (approvalTemplateId: string) => {
  return getAmazonApprovalURL() + 'Template/Details/' + approvalTemplateId;
};

export const convertApprovalWorkflowIDToLink = (approvalWorkflowId: string) => {
  return getAmazonApprovalURL() + 'Approval/Details/' + approvalWorkflowId;
};

export const RequestInformation = ({ request }) => (
  <>
    <Container header={<Header variant={'h2'}>Request details</Header>}>
      <KeyValuePairs
        columns={4}
        items={[
          { label: 'Requested by', value: request.requestedBy },
          { label: 'Request group', value: request.requestGroup },
          { label: 'Decided by', value: request.decidedBy },
          { label: 'Data owner', value: request.owner },
          { label: 'Status', value: StatusIcon({ status: request.status }) },
          request.statusReason ? { label: 'Status reason', value: request.statusReason } : undefined,
          // only defined for denied status.
          request.reasonOfAction ? { label: 'Status reason', value: request.reasonOfAction } : undefined,
          { label: 'Request date', value: request.timeOfRequest },
          { label: 'Decision date', value: request.timeOfDecision },
          request.principal ? { label: 'External account', value: request.principal } : undefined,
          { label: 'Catalog ID', value: request.catalogId },
          request.clusterId ? { label: 'Cluster ID', value: request.clusterId } : undefined,
          request.redshiftWorkgroupName
            ? { label: 'Redshift workgroup name', value: request.redshiftWorkgroupName }
            : undefined,
          { label: 'Database name', value: request.databaseName },
          request.schemaName ? { label: 'Schema name', value: request.schemaName } : undefined,
          { label: 'Table name', value: request.tableName },
          request.columnNames
            ? {
                label: `Columns ${request.columnWildCard ? `(${request.columnWildCard})` : ''}`,
                value: request.columnNames,
              }
            : undefined,
          request.columnWildCard ? { label: 'Columns wildcard', value: request.columnWildCard } : undefined,
          request.permissions ? { label: 'Permissions', value: request.permissions } : undefined,
          request.grantablePermissions
            ? { label: 'Grantable permissions', value: request.grantablePermissions }
            : undefined,
          request?.simTickets?.length > 0
            ? {
                label: 'SIM ticket links',
                value: request?.simTickets?.map((st) => {
                  return (
                    <>
                      <Link href={st?.simTicketLink} external={true}>
                        {st?.simTemplateName}
                      </Link>{' '}
                      <br />
                    </>
                  );
                }),
              }
            : undefined,
        ].filter((item) => item != undefined)}
      />
      <KeyValuePairs
        columns={4}
        items={[
          { label: 'Use case', value: request.useCase },
          { label: 'Reason for action', value: request.reasonOfAction },
        ].filter((item) => item != undefined)}
      />
    </Container>
    {request.approvalsWorkflow?.length > 0 && (
      <Table
        columnDefinitions={[
          {
            id: 'approvalTemplateId',
            header: 'Aprpoval template ID',
            cell: (e) => (
              <Link href={convertApprovalTemplateIDToLink(e['approvalTemplateId'])} external={true}>
                {e['approvalTemplateId']}
              </Link>
            ),
          },
          {
            id: 'approvalworkflowId',
            header: 'Approval workflow ID',
            cell: (e) => (
              <Link href={convertApprovalWorkflowIDToLink(e['approvalWorkflowId'])} external={true}>
                {e['approvalWorkflowId']}
              </Link>
            ),
          },
          {
            id: 'approvalWorkflowStatus',
            header: 'Approval workflow status',
            cell: (e) => e['approvalWorkflowStatus'],
          },
        ]}
        items={deDupeApprovalsInfoByApprovalWorkflowId(request.approvalsWorkflow)}
        loadingText='Loading resources'
        header={<Header>Approval workflow details</Header>}
      />
    )}
  </>
);
